import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import DeleteModel from "common/deleteModel/deleteModel"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "../../../components/Common/TableContainer"
import { useLocation, useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Modal,
    ModalBody,
    ModalHeader,
    UncontrolledTooltip,
} from "reactstrap"
import toast from "react-hot-toast"
import { dateFormat } from "pages/Common"
import useApi from "common/ApiMiddlewere"
import ErrorModel from "common/errorModel/errorModel"
import breadcrumbs from "../../../common/Breadcrumbs"
import { routes } from "routes/path"
import IncomeModel from "./IncomeModel"
import IncomeTable from "./IncomeTable"

function Income() {
    const navigate = useNavigate()
    const { deleteApi, postApi } = useApi()
    let { pathname } = useLocation()
    const [modal, setModal] = useState(false)
    const [tableData, setTableData] = useState([])
    const [FollowupModal, setFollowupModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [IncomeDetails, setIncomeDetails] = useState({
        Id: "",
        Date: "",
        Amount: 1000,
        Name: "",
        PaymentMode: 1,
        Details: ""
    })
    const [isLoading, setIsLoading] = useState(false)
    const [followDetailId, setfollowDetailId] = useState()
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [searchText, setSearchText] = useState("")
    const [TotalRecords, setTotalRecords] = useState(0.0)
    const [displayStart, setDisplayStart] = useState(1)
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)

    // filterData for Income
    const filterData = textFilter => {
        // setSearchText(textFilter)
    }

    // pageSize function
    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    const handleFollowUp = Details => {
        setIncomeDetails(Details)
        setIsEdit(false)
        toggle()
    }

    const toggle = () => {
        setModal(!modal)
    }

    const followModel = id => {
        setFollowupModal(!FollowupModal)
        setfollowDetailId(id)
    }

    const getTableData = () => {
        setIsLoading(true)
        postApi("income/list", {
            status: 0,
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "",
        }).then(({ data, status }) => {
            if (status === 200) {
                setIsLoading(false)
                setTableData(data.List)
                setTotalRecords(data.TotalRecords)
            } else {
                setIsLoading(false)
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }

    useEffect(() => {
        getTableData()
    }, [rowsPerPage, searchText, displayStart])

    const confirmDelete = id => {
        DeleteModel.confirmDeleteInquiry({
            title: "Are you sure? ",
            text: "You want to delete this inquiry permanently? ",
            isMobile,
        })
            .then(response => {
                setIsLoading(true)
                if (response == true) {
                    deleteApi(`income/delete?id=${id}`).then(({ data, status }) => {
                        if (status === 200) {
                            const updatedArray = tableData
                                .map(obj => (obj.Id !== id ? obj : null))
                                .filter(Boolean)
                            setTableData(updatedArray)
                            toast.success("Sucessfully deleted", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            setIsLoading(false)
                        } else {
                            setIsLoading(false)
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        }
                    })
                } else {
                    setIsLoading(false)
                }
            })
            .catch(e => {
                console.log(e)
            })
    }

    const columns = useMemo(
        () => [
            {
                Header: "Name",
                accessor: "Name",
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}
                    >
                        Amount
                    </div>
                ),
                accessor: "Amount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}
                        >
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.Amount || 0)}
                        </div>
                    )
                },

            },
            {
                Header: "Payment",
                accessor: "PaymentMode",
                width: "7%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.PaymentMode == "1"
                            ? "Cash"
                            : row.original.PaymentMode == "2"
                                ? "Bank" : ''}
                    </p>
                ),
            },
            {
                Header: "Date",
                accessor: "Date",
                width: "7%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.Date == null
                            ? "N/A"
                            : dateFormat(row.original.Date.split("T")[0], "dd/MM/yyyy")}
                    </p>
                ),
            },
            {
                Header: "Create On",
                accessor: "CreatedOn",
                width: "7%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.Date == null
                            ? "N/A"
                            : dateFormat(row.original.Date.split("T")[0], "dd/MM/yyyy")}
                    </p>
                ),
            },
            {
                Header: "Details",
                accessor: "Details",
                Cell: ({ row }) => (
                    <p
                        className=" mb-0"
                        // style={{width:"120px"}}
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={`${row.original.Details == null ? '' : row.original.Details}`}
                    >
                        {row.original.Details.length > 40
                            ? `${row.original.Details.substr(0, 40)}...`
                            : row.original.Details == ""
                                ? "N/A"
                                : row.original.Details}
                    </p>
                ),
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "6%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">

                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleFollowUp(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>

                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => confirmDelete(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>

                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )

    const handleAddIncome = () => {
        setIncomeDetails()
        toggle();
    }

    document.title = `Income | ${localStorage.getItem("ShopName")}`

    return (
        <div className="page-content">
            <div className="container-fluid">
                {isLoading && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].title}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                />
                <Card>
                    <CardBody>
                        <IncomeTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            handleUserClick={handleAddIncome}
                            customPageSize={10}
                            isLoading={isLoading}
                            filterData={filterData}
                            pagePerSize={pagePerSize}
                            TotalRecords={TotalRecords}
                            className="custom-header-css"
                        />
                    </CardBody>
                </Card>
                <IncomeModel
                    modal={modal}
                    toggle={toggle}
                    IncomeDetails={IncomeDetails}
                    getTableData={getTableData}
                />
            </div>
        </div>
    )
}
Income.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
}

export default Income
